import FamilyDetailsForm from './family-details-form'

export default FamilyDetailsForm
